import I18n from 'I18n';
export function pixelStepperFormatter(val) {
  return val != null ? `${I18n.formatNumber(val, {
    precision: 1
  })}px` : val;
}
export function pixelStepperParser(val) {
  return parseInt(val, 10);
}
export function getAspectRatio(width, height) {
  return width / height;
}